export { default } from './JSONLike.component';
